module.exports = __webpack_public_path__ + "img/column.8ce5f484.svg";